import React from 'react'
import { useModel } from '@morningtrain/react-resources'

function ChangeQuantity (props) {
  const model = useModel()

  const [count, setCount] = React.useState(1)

  function decrease () {
    if (count > 1) {
      setCount(count - 1)
    }
  }

  function increase () {
    setCount(count + 1)
  }

  React.useEffect(() => {
    model.set('quantity', count)
  }, [model, count])

  return (
    <div className='quantity-input'>
      <div className='quantity-input__btn-wrap'>
        <button onClick={decrease}>-</button>
      </div>

      <div className='quantity-input__text'>
        <input value={count} onChange={e => setCount(parseInt(e.target.value) || count)} />
      </div>

      <div className='quantity-input__btn-wrap'>
        <button onClick={increase}>+</button>
      </div>
    </div>
  )
}

export default ChangeQuantity
